<template>

    <div class="login-oauth">

        <div>
            <foxy-loader></foxy-loader>
            <p class="text-lRegular color__moon mt__16">{{$t('connexion_in_progress')}}</p>
        </div>

    </div>

</template>

<script>
import OAuthMicrosoft from '../modules/o-auth/microsoft'
import { configuration } from '../../configuration'

import FoxyLoader from '../components/FoxyLoader'


export default {

    name: 'login-o-auth',

    components: {
        FoxyLoader
    },

    data() {
        return {
            provider: 'microsoft'
        }
    },

    async mounted() {

        await this.initData()

    },

    methods: {

        async initData() {

            // TODO: currently only Microsoft is supported

            const { email } = OAuthMicrosoft.getOAuthStep1Data()

            // Navigate to the Microsoft server to initiate the login process and get in return the authenticate code

            const scopeUrlStr = configuration.oauth.microsoft.scope.replace(/ /g, '%20')

            const loginMicrosoft = ['https://login.microsoftonline.com/common/oauth2/v2.0/authorize?',
                `client_id=${configuration.oauth.microsoft.clientId}`,
                '&response_type=code',
                `&redirect_uri=${configuration.oauth.microsoft.redirectUri}`,
                '&response_mode=query',
                `&scope=${scopeUrlStr}`,
                '&state=step1',
                `&login_hint=${email}`,
                `&code_challenge=${OAuthMicrosoft.generateCodeChallenge()}`,
                '&code_challenge_method=S256'
            ]

            window.location.href = loginMicrosoft.join('')

        }
    }
}
</script>

<style lang="scss" scoped>

.login-oauth {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
}


</style>